export default __webpack_public_path__ + "537bbcf.png";